import { render } from "./CalloutComponent.vue?vue&type=template&id=2c54b332"
import script from "./CalloutComponent.vue?vue&type=script&lang=js"
export * from "./CalloutComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__